import { Controller } from "@hotwired/stimulus";
export default class default_1 extends Controller {
    connect() { }
    showMenu(event) {
        this._log("showMenu:start");
        this.dialogController = this.application.getControllerForElementAndIdentifier(this.dialogTarget, "dialog");
        this.dialogPromise = this.dialogController.show();
        this._log("showMenu:end");
    }
    hideMenu(event) {
        var _a;
        this._log("hideMenu:start");
        this.dialogPromise = undefined;
        (_a = this.dialogController) === null || _a === void 0 ? void 0 : _a.close();
        this._log("hideMenu:end");
    }
    _log(text) {
        console.log(this.identifier + ":" + text);
    }
}
default_1.targets = ["dialog"];
default_1.values = {
    placeholder: String,
};
